<script setup lang="ts">import { ref as _ref } from 'vue';

import { useFavoritesStore } from '@consumer/services/favorites/store'
import Favorites from './FavoritesMenu/Favorites.vue'
import FavoritesButton from './FavoritesMenu/FavoritesButton.vue'

const open = _ref(false)

const favorites = useFavoritesStore()

watchEffect(() => {
  if (open.value) favorites.loadRecentlyAddedFavorites()
})
</script>

<template>
  <div class="flex gap-5 items-center text-v2-tertiary">
    <div class="relative">
      <FavoritesButton @click="open = !open"/>

      <GMobileModal v-model:open="open">
        <template #header>
          <div class="font-semibold text-lg text-center">
            {{ favorites.header }}
          </div>
        </template>
        <Favorites @click="open = false"/>
      </GMobileModal>
    </div>
  </div>
</template>
